import React, { Component } from 'react';

import FirstHeader from '../components/firstHeader'
import Header from '../components/header'
import Middlesection from '../components/middleSection'
import Footer from '../components/footer'
import SectionInformationBoxes from '../components/sectionInformationBoxes'

import SectionLegal from './sectionLegal'

class routeLegal extends Component {
  render() {
    const selection = this.props.selection
    return (
      <div className='route-section-text'>
        <FirstHeader />
        <Header isMenu={true} />

        <SectionLegal selection={selection} />
        <SectionInformationBoxes/>

        <Footer />
      </div>
    );
  }
}

export default routeLegal;



// WEBPACK FOOTER //
// ./src/shared/routes/routeLegal/index.js